export class Enviroment{
    identity: any;
    api: any;
    constructor(){
        this.api = process.env.REACT_APP_API_URL;
        this.identity = process.env.REACT_APP_IDENTITY_URL;
    }
}